import { glossary } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function GlossarySection() {
  return (
    <section id="glossary" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="名词说明"
          title="几个常见说法到底指什么"
          desc="搜索时经常遇到的几个说法容易混淆，这里用一句话把它们的含义与关系讲清楚，方便你判断该看哪一部分内容。"
        />

        <dl className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {glossary.map((item) => (
            <div key={item.term} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <dt className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center text-accent-600">
                  <i className="ri-price-tag-3-line"></i>
                </span>
                {item.term}
              </dt>
              <dd className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}